import { useEffect, useRef, useState } from "react";
import h337 from "heatmap.js";

export default function HeatmapCanvas({ points }) {
    const containerRef = useRef(null);
    const [scaledPoints, setScaledPoints] = useState([]);

    useEffect(() => {
        if (!containerRef.current || !points?.length) return;

        const rect = containerRef.current.getBoundingClientRect();

        if (!rect.width || !rect.height) return;

        const heat = h337.create({
            container: containerRef.current,
            radius: 55,
            blur: 0.9,
            maxOpacity: 0.75,
            gradient: {
                0.2: "blue",
                0.4: "cyan",
                0.6: "lime",
                0.8: "yellow",
                1.0: "red"
            }
        });

        const data = points.map(p => {
            const x = Math.round(parseFloat(p.x) * rect.width);
            const y = Math.round(parseFloat(p.y) * rect.height);

            return {
                x,
                y,
                value: Number(p.value),
                table_no: p.table_no
            };
        });

        const max = Math.max(...data.map(d => d.value), 1);

        heat.setData({ max, data });
        setScaledPoints(data);

    }, [points]);

    return (
        <div className="flex flex-col items-center gap-4">

            {/* Heatmap Container */}
            <div className="relative w-[1000px] h-[550px] border bg-gray-50">
                <div ref={containerRef} className="absolute inset-0" />

                {/* Labels */}
                {scaledPoints.map((p, i) => (
                    <div
                        key={i}
                        className="absolute text-xs font-semibold text-black pointer-events-none text-center"
                        style={{
                            left: p.x,
                            top: p.y,
                            transform: "translate(-50%, -50%)"
                        }}
                    >
                        T{p.table_no} <br /> {p.value}
                    </div>
                ))}
            </div>

            {/* Color Scale Legend */}
            <div className="w-[400px]">
                <div className="h-4 rounded bg-gradient-to-r from-blue-500 via-cyan-400 via-lime-400 via-yellow-400 to-red-500"></div>
                <div className="flex justify-between text-xs mt-1">
                    <span>Low</span>
                    <span>Medium</span>
                    <span>High</span>
                </div>
            </div>
        </div>
    );
}
